import clsx from 'clsx';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { Fade } from '../Animations';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);
  return null;
};

const FullscreenFader = () => {
  const [show, setShow] = React.useState(true);
  const { pathname } = useLocation();
  React.useEffect(() => {
    setShow(true);
  }, [pathname]);
  if (!show) return null;
  return (
    <Fade
      className="absolute bg-black w-full h-full z-50"
      onFinishFade={() => setShow(false)}
      type="fade-out"
    />
  );
};

type MainLayoutProps = {
  children: React.ReactNode;
};
export const MainLayout = ({ children }: MainLayoutProps) => {
  React.useEffect(() => {
    // https://www.chromestatus.com/feature/5745543795965952
    document.addEventListener('touchstart', () => {}, { passive: true });
  }, []);
  return (
    <div className={clsx('bg-black h-full', 'text-white text-opacity-80 font-serif')}>
      <ScrollToTop />
      {children}
      <FullscreenFader />
    </div>
  );
};
